// @flow

import type {ApiSuccess, PureAction} from '@travel-frontend/state-handling-sdk';
import type {AsyncAction} from 'redux/types';

import {ASYNC_TYPES, PURE} from '@travel-frontend/state-handling-sdk';
import axios from 'axios';

import {config as cfg} from 'config';

export const GET_CUSTOMER_VOUCHERS =
  'v1/customerVouchers/GET_CUSTOMER_VOUCHERS';
export const RESET_CUSTOMER_VOUCHERS =
  'v1/customerVouchers/RESET_CUSTOMER_VOUCHERS';

export type GetCustomerVouchersSuccess = ApiSuccess<[], *>;

export const fetchCustomerVouchers = (customerId: string): AsyncAction => {
  return {
    types: ASYNC_TYPES(GET_CUSTOMER_VOUCHERS),
    callAPI: () =>
      axios
        .get(`${cfg.bookingServiceUrl}/login/customervouchers/${customerId}`)
        .then((res) => res.data || null),
  };
};

export const resetCustomerVouchers = (): PureAction => ({
  type: PURE(RESET_CUSTOMER_VOUCHERS),
});
